import { clsx } from "@/utils";
import { ClientsTab } from "./tabs";
import { useGetClientsParams } from "./useGetClientsParams";

const TABS: { value: ClientsTab; name: string }[] = [
  { value: "active", name: "My Clients" },
  { value: "pending", name: "Pending Clients" },
  { value: "archived", name: "Archived Clients" },
];

/**
 * Top-level partition of the client list into My Clients (active), Pending Clients
 * (invited, setup incomplete) and Archived Clients (removed). Each tab maps to a single
 * `account_status`; pagination resets and search persists via
 * {@link useClientsTab}/{@link useGetClientsParams}.
 */
export const ClientsTabs = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  const { tab, setTab } = useGetClientsParams();

  return (
    <nav role="tablist" aria-label="Client status" className={clsx("flex items-center", className)} {...props}>
      {TABS.map(({ value, name }) => {
        const isActive = value === tab;
        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => setTab(value)}
            className={clsx(
              "-mb-px flex h-9 items-center justify-center px-4 py-2 text-base font-semibold leading-5 transition-colors",
              isActive ? "border-b-2 border-primary text-primary-dark" : "text-neutral-silver-gray"
            )}
          >
            {name}
          </button>
        );
      })}
    </nav>
  );
};
